/**
 * App version and build metadata.
 *
 * `APP_VERSION` comes from package.json at build time via Vite's define option.
 * `BUILD_HASH` is a short git SHA (or timestamp fallback) injected at build time.
 *
 * Together they form a human-readable build identifier useful for customer
 * support (e.g. "0.1.0+abc1234") and for detecting stale cached chunks after
 * a deployment.
 */

export const APP_VERSION: string = __APP_VERSION__;
export const BUILD_HASH: string = __BUILD_HASH__;

/** e.g. "0.1.0+abc1234" */
export const BUILD_ID = `${APP_VERSION}+${BUILD_HASH}`;
